export default {
    meta: {
        title: '登录',
        isShowHeader: false,
    },
};
